import { createAction } from 'redux-actions'

export const removeFromProductCompare = createAction('SEARCH_RESULT_PAGE/REMOVE_FROM_PRODUCT_COMPARE')
